import { useCallback, useMemo, useRef, useState } from 'react';

import { type ChessArrow, type ChessUserArrow } from '@exports/ChessBoard';

export function useArrows(fen: string, stockfishArrows?: ChessArrow[]) {
  const [userArrows, setUserArrows] = useState<ChessUserArrow[]>([]);

  const prevFenRef = useRef(fen);
  if (prevFenRef.current !== fen) {
    prevFenRef.current = fen;
    if (userArrows.length > 0) setUserArrows([]);
  }

  const onUserArrow = useCallback(
    (_: ChessUserArrow | null, next?: ChessUserArrow[]) => setUserArrows(next ?? []),
    [],
  );

  const arrows = useMemo(
    () => (stockfishArrows ? [...stockfishArrows, ...userArrows] : userArrows),
    [stockfishArrows, userArrows],
  );

  return { arrows, onUserArrow };
}
